import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { HeaderBar } from 'components/HeaderBar';
import PageLayout from 'components/PageLayout';
import { useAuthState } from 'state/useAuthState';
import { OrganizationProFeaturesDownstate } from 'features/organizations/components/OrganizationProFeaturesDownstate';
import { Redirect } from 'react-router-dom';
import { SupportUsContent } from './SupportUsContent';
import { MembershipPlanProvider } from './MembershipPlanProvider';

const Content = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('supportUs.title')}</title>
      </Helmet>
      <MembershipPlanProvider>
        <SupportUsContent />
      </MembershipPlanProvider>
    </>
  );
};

export const SupportUs = (): JSX.Element => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { isOrganizationUser, hasActiveMembership, isProMember } =
    useAuthState();

  if (isOrganizationUser && hasActiveMembership && isProMember) {
    return <Redirect to="/" />;
  }

  const ContentComponent = isOrganizationUser
    ? OrganizationProFeaturesDownstate
    : Content;

  const title = isOrganizationUser ? '' : t('supportUs.title');

  return (
    <PageLayout data-cname="SupportUsPage">
      {{
        content: <ContentComponent />,
        headerBar: (
          <HeaderBar
            title={title}
            action="/"
            bgColor={theme.palette.background.membership}
            elevation={0}
          />
        ),
      }}
    </PageLayout>
  );
};
